module.exports = __webpack_public_path__ + "static/media/rotarylogo.21beb3bf.png";